import { RepositoryBuilder } from 'alto-orm/lib/orm';

import Product from './product';

const FoodRepository = new RepositoryBuilder;

FoodRepository.registerRelation(Product, '/food/crud/products');

export default FoodRepository; // takes backendUrl and auth
